import { useState, useEffect } from "react";
import { ReactLenis } from "lenis/react";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/marketing/Navbar";
import Hero from "@/components/marketing/Hero";
import Marquee from "@/components/marketing/Marquee";
import Services from "@/components/marketing/Services";
import Manifesto from "@/components/marketing/Manifesto";
import GlobalReach from "@/components/marketing/GlobalReach";
import FAQ from "@/components/marketing/FAQ";
import ContactForm from "@/components/marketing/ContactForm";
import Footer from "@/components/marketing/Footer";
import { useSeo } from "@/lib/useSeo";

function shouldSkipIntro() {
  try {
    const navType = performance.getEntriesByType("navigation")[0]?.type;
    return navType === "navigate" && document.referrer.startsWith(window.location.origin);
  } catch {
    return false;
  }
}

export default function HomePage() {
  const [ready, setReady] = useState(shouldSkipIntro);
  useSeo(
    "ClaimSpace LegalTech — Patents, Trademarks, Designs & Copyrights",
    "ClaimSpace LegalTech Pvt Ltd is a full-service IPR firm: patents, trademarks, designs, copyrights and patent analytics — from search and drafting to filing, prosecution and renewal, in India and worldwide."
  );
  useEffect(() => {
    if (!ready) return;
    const hash = window.location.hash;
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) {
      const t = setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
      return () => clearTimeout(t);
    }
  }, [ready]);
  return (
    <ReactLenis root options={{ lerp: 0.05, smoothWheel: true }}>
      <div data-testid="home-page" className="bg-navy-950">
        <div className="noise-overlay" />
        {!ready && <Preloader onFinish={() => setReady(true)} />}
        <Navbar />
        <Hero start={ready} />
        <Marquee />
        <Services />
        <Manifesto />
        <GlobalReach />
        <FAQ />
        <ContactForm />
        <Footer />
      </div>
    </ReactLenis>
  );
}
